import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'markdown'
})
export class MarkdownPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): SafeHtml {
    if (!value) {
      return '';
    }

    // Simple markdown to HTML converter for basic markdown
    let html = value;
    
    // Convert headers
    html = html.replace(/^### (.*$)/gim, '<h3>$1</h3>');
    html = html.replace(/^## (.*$)/gim, '<h2>$1</h2>');
    html = html.replace(/^# (.*$)/gim, '<h1>$1</h1>');
    
    // Convert bold
    html = html.replace(/\*\*(.*?)\*\*/gim, '<strong>$1</strong>');
    
    // Convert italic
    html = html.replace(/\*(.*?)\*/gim, '<em>$1</em>');
    
    // Convert inline code
    html = html.replace(/`(.*?)`/gim, '<code>$1</code>');
    
    // Convert line breaks to <br>
    html = html.replace(/\n/gim, '<br>');
    
    // Convert bullet lists (lines starting with - or *)
    html = html.replace(/^[\-\*] (.*$)/gim, '<li>$1</li>');
    html = html.replace(/(<li>.*<\/li>)/s, '<ul>$1</ul>');
    
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}

